<template>
  <section id="contact" class="contact section-show">
    <div class="container">
      <div class="section-title">
        <h2>اطلاعات هویتی شما</h2>
      </div>
      <form method="post" class="email-form mt-4" @submit="checkForm">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="label">کدسهامداری</label>
            <input
              type="text"
              class="form-control"
              v-model="Identity.tradingCode"
              disabled
            />
            <label class="label">نوع مشتری</label>
            <select
              id="legal"
              class="select-form"
              v-on:change="changelegal($event)"
              v-model="Identity.legal"
            >
              <option :key="0" :value="false">حقیقی</option>
              <option :key="1" :value="true">حقوقی</option>
            </select>
            <label class="label">نام کاربری</label>
            <input
              type="text"
              class="form-control"
              v-model="Identity.userName"
              disabled
            />
            <label class="label">نام <img :src="star" /></label>
            <input
              type="text"
              id="name"
              class="form-control"
              v-model="Identity.name"
            />
            <p class="error" v-if="this.errors.name">
              <b>لطفا نام خود را وارد نمایید</b>
            </p>
            <label class="label">نام خانوادگی <img :src="star" /></label>
            <input
              type="text"
              id="family"
              class="form-control"
              v-model="Identity.family"
            />
            <p class="error" v-if="this.errors.family">
              <b>لطفا نام خانوادگی خود را وارد نمایید</b>
            </p>
          </div>
          <div class="col-md-6 form-group mt-3 mt-md-0">
            <label class="label">نام پدر </label>
            <input
              id="fathername"
              type="text"
              class="form-control"
              v-model="Identity.fatherName"
            />
            <label class="label">کدملی <img :src="star" /></label>
            <input
              id="codemelli"
              type="text"
              class="form-control"
              v-model="Identity.codeMelli"
              @keypress="validateNumber"
            />
            <p class="error" v-if="this.errors.codemelli">
              <b>لطفا کدملی خودرا وارد نمایید</b>
            </p>
            <p class="error" v-if="this.errors.codemellilength">
              <b>لطفا 10 رقم وارد کنید</b>
            </p>
            <label class="label">شناسه ملی</label>
            <input
              type="text"
              class="form-control"
              v-model="Identity.shenasMelli"
              @keypress="validateNumber"
            />
            <label class="label"
              >شماره شناسنامه / شماره ثبت <img :src="star"
            /></label>
            <input
              id="registerNum"
              type="text"
              class="form-control numbering"
              v-model="Identity.registerNum"
              @keypress="validateNumber"
            />
            <p class="error" v-if="this.errors.registerNum">
              <b>لطفا شماره شناسنامه / شماره ثبت وارد نمایید</b>
            </p>
            <label class="label">تاریخ تولد</label>
            <CustomDatePicker v-model="Identity.dob"></CustomDatePicker>
          </div>
        </div>
        <div class="text-center" style="margin-top: 20px">
          <button type="submit" class="btnsend">ثبت تغییرات</button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import { UpdateIdentity, GetIdentity } from "@/API/API";
import star from "../assets/img/star.png";

export default {
  name: "Identity",
  data() {
    return {
      star,
      Identity: {},
      errors: {
        name: "",
        family: "",
        codemelli: "",
        registerNum: "",
        codemellilength: "",
        length: 0,
      },
    };
  },
  async created() {
    this.Identity = (await GetIdentity(this.$store.getters.seq)).data.result;
  },
  methods: {
    validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    changelegal: function changelegal(event) {
      this.Identity.legal = event.target.value;
    },
    checkForm: function (e) {
      e.preventDefault();
      this.errors = [];

      if (!this.Identity.name) {
        this.errors.name = true;
        this.errors.length += 1;
      }
      if (!this.Identity.family) {
        this.errors.family = true;
        this.errors.length += 1;
      }
      if (!this.Identity.codeMelli) {
        this.errors.codemelli = true;
        this.errors.length += 1;
      }
      if (!this.Identity.registerNum) {
        this.errors.registerNum = true;
        this.errors.length += 1;
      }
      if (
        this.Identity.codeMelli.toString().length != 10 &&
        this.Identity.codeMelli.toString().length != 0
      ) {
        this.errors.codemellilength = true;
        this.errors.length += 1;
      }
      if (this.errors.length == 0) {
        this.Identity.legal = Boolean(this.Identity.legal);
        UpdateIdentity(this.Identity)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "ویرایش اطلاعات با موفقیت انجام شد",
              confirmButtonColor: "#1e682d",
              confirmButtonText: "باشه",
            });
          })
          .catch(() => {
            this.loginError = true;
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "ویرایش اطلاعات با خطا مواجه شد",
              confirmButtonColor: "#900C3F",
              confirmButtonText: "باشه",
            });
          });
      }
    },
  },
};
</script>
<style scoped>
.section-title h2 {
  font-size: 18px;
  font-weight: 700;
  padding: 0;
  line-height: 18px;
  margin: 30px 0 20px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #111;
  font-family: "iransans", Lato, sans-serif;
  padding-bottom: 15px;
  position: relative;
}
.section-title h2::after {
  content: "";
  width: 190px;
  height: 2px;
  background: #d1a44f;
  bottom: 0;
  top: auto;
  position: absolute;
  right: 0;
}
.email-form input {
  text-align: right;
}
</style>
